import { RefObject, useEffect } from 'react';

const REACT_SELECT_OPTION_ID_PREFIX = 'react-select-';

// React Select options are rendered outside of the parent component, so we need
// to ignore closing the menu if the user clicks on one of the options.
const isReactSelectOption = (element: HTMLElement) => {
  const elementClickedId = element?.getAttribute('id');

  return elementClickedId?.includes(REACT_SELECT_OPTION_ID_PREFIX);
};

export const useCloseMenuIfClickedOutside = (
  ref: RefObject<HTMLElement>,
  isMenuOpen: boolean,
  closeMenu
) => {
  const handleClickOutside = (event: MouseEvent) => {
    if (
      ref.current &&
      !ref.current.contains(event.target as Node) &&
      !isReactSelectOption(event.target as HTMLElement) &&
      isMenuOpen
    ) {
      closeMenu();
    }
  };

  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);

    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, [isMenuOpen]);
};
